import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["points", "fill"]
const _hoisted_2 = ["x", "y", "font-size"]

import { computed } from 'vue'

interface Props {
  x: number
  y: number
  id: number
  radius: number
  mode?: 'origin' | 'fight-fortress' | 'gold-center' | 'black-swamp' | 'chance-place' | 'secret-place' | 'normal'
  fill?: string
  text?: string
}

const stroke = '#333'

export default /*@__PURE__*/_defineComponent({
  __name: 'HexUnit',
  props: {
    x: {},
    y: {},
    id: {},
    radius: {},
    mode: {},
    fill: {},
    text: {}
  },
  emits: ['onHexClick'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const points = computed(() => {
  const pts = []
  for (let i = 0; i < 6; i++) {
    const angle = Math.PI / 3 * i
    const px = props.x + props.radius * Math.cos(angle)
    const py = props.y + props.radius * Math.sin(angle)
    pts.push(`${px},${py}`)
  }
  return pts.join(' ')
})

const getFill = () => {
  switch (props.mode) {
    case 'origin':
      return '#8c8c8c'
    case 'fight-fortress':
      return '#ff9924'
    case 'gold-center':
      return '#fc3232'
    case 'secret-place':
      return '#3297fc'
    case 'black-swamp':
      return '#1e1e1e'
    case 'chance-place':
      return '#0ccb12'
    default:
      return '#ffffff'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("g", {
    class: "hex-unit",
    style: {"cursor":"pointer"},
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onHexClick', props.id)))
  }, [
    _createElementVNode("polygon", {
      points: points.value,
      fill: _ctx.fill ?? getFill(),
      stroke: stroke,
      "stroke-width": 1
    }, null, 8, _hoisted_1),
    _createElementVNode("text", {
      x: props.x,
      y: props.y,
      "text-anchor": "middle",
      "dominant-baseline": "middle",
      "font-size": _ctx.radius / 1.5,
      fill: "white"
    }, _toDisplayString(_ctx.text), 9, _hoisted_2)
  ]))
}
}

})